// A third-party delivery-estimate app injects a volatile "properties[Arriving]"
// hidden field (the estimated delivery date text, e.g. "Wednesday, 26 Aug") into
// every add-to-cart form on the page, sometimes several times over. Its value can
// differ between two otherwise-identical "Add to basket" submissions of the same
// variant (e.g. across a dispatch cutoff/day boundary), which changes the cart
// line's merge key and makes Shopify create a duplicate line instead of combining
// quantities. It isn't displayed or used anywhere in this theme's cart, so disable
// it wherever it appears (disabled fields are excluded from form submission,
// regardless of whether the form is submitted natively or via AJAX).
(function () {
  function disableVolatileDeliveryProps(root) {
    (root || document).querySelectorAll('input[name="properties[Arriving]"]').forEach(function (el) {
      el.disabled = true;
    });
  }
  disableVolatileDeliveryProps();
  new MutationObserver(function () { disableVolatileDeliveryProps(); }).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      // A third-party delivery-estimate app injects a volatile "properties[Arriving]"
      // field (the estimated delivery date text) into this form. Its value can differ
      // between two otherwise-identical "Add to basket" submissions (e.g. across a
      // dispatch cutoff/day boundary), which changes the cart line's merge key and
      // causes Shopify to create a duplicate line instead of combining quantities.
      // It isn't displayed or used anywhere in the cart, so strip it before submitting.
      formData.delete('properties[Arriving]');

    if (this.cart) {
      formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    
      console.log("🔍 FormData values:");
      for (let [key, value] of formData.entries()) {
        console.log(`${key}:`, value);
      }
    }
    
    config.body = formData;
    
    console.log("📦 Config Body FormData:", config);

      

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => {
                if (this.cart) {
                  this.cart.renderContents(response);
                  if (window.innerWidth <= 767 && typeof this.cart.close === 'function') {
                    this.cart.close();
                  }
                }
                if (window.innerWidth <= 767 && window.amazonMobileCartPopup) {
                  window.amazonMobileCartPopup.show(response);
                }
              });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            if (this.cart) {
              this.cart.renderContents(response);
              if (window.innerWidth <= 767 && typeof this.cart.close === 'function') {
                this.cart.close();
              }
            }
            if (window.innerWidth <= 767 && window.amazonMobileCartPopup) {
              window.amazonMobileCartPopup.show(response);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');

          // if(typeof BOLD === 'object' && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function') {
          //  BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded");
          // }
          
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
